// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2nzhi","requiredAsterisk":"Info_requiredAsterisk__2_pcL"};